export type ServicesTab = "Service Types" | "Requests";

export const SERVICES_STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "ACTIVE", label: "Active" },
  { value: "DISABLED", label: "Disabled" },
];
